import React, { useState, useRef } from 'react';
import Portal from './Portal.js';

const position = (p) => ({
	current: p,
	negate() {
		if (this.current === 'left') return 'right';
		if (this.current === 'right') return 'left';
		if (this.current === 'top') return 'bottom';
		if (this.current === 'bottom') return 'top';
	},
	isHorizontal() {
		return this.current === 'left' || this.current === 'right';
	},
	isVertical() {
		return this.current === 'top' || this.current === 'bottom';
	}
});

const point = () => ({
	x: null,
	y: null,
	reset(p) {
		this.x = p.x;
		this.y = p.y;
		// },
		// restrictRect(rect) {
		// 	if (this.x < rect.l) this.x = rect.l;
		// 	else if (this.x > rect.r) this.x = rect.r;
		// 	if (this.y < rect.t) this.y = rect.t;
		// 	else if (this.y > rect.b) this.y = rect.b;
		// }
	}
});

const getPoint = (el, tt, placement, space) => {
	let recurCount = 0;
	const pt = point();
	const bdys = {
		l: space,
		t: space,
		r: document.body.clientWidth - (tt.clientWidth + space),
		b: window.innerHeight - (tt.clientHeight + space)
	};
	const elRect = el.getBoundingClientRect();

	return (function recursive(placement) {
		recurCount++;
		const pos = position(placement);
		switch (pos.current) {
			case 'left':
				pt.x = elRect.left - (tt.offsetWidth + space);
				pt.y = elRect.top + (el.offsetHeight - tt.offsetHeight) / 2;
				break;
			case 'right':
				pt.x = elRect.right + space;
				pt.y = elRect.top + (el.offsetHeight - tt.offsetHeight) / 2;
				break;
			case 'top':
				pt.x = elRect.left + (el.offsetWidth - tt.offsetWidth) / 2;
				pt.y = elRect.top - (tt.offsetHeight + space);
				break;
			default:
				pt.x = elRect.left + (el.offsetWidth - tt.offsetWidth) / 2;
				pt.y = elRect.bottom + space;
		}

		if (recurCount < 3)
			if (
				(pos.isHorizontal() && (pt.x < bdys.l || pt.x > bdys.r)) ||
				(pos.isVertical() && (pt.y < bdys.t || pt.y > bdys.b))
			) {
				pt.reset(recursive(pos.negate()));
			}

		// restrict to rect boundary
		// pt.restrictRect(bdys);

		return pt;
	})(placement);
};

function Tooltip({
	text,
	placement = 'top',
	space = 2,
	children,
	disabled = 0,
	delay,
	bg
}) {
	const [
		show,
		setShow
	] = useState(0);
	const posref = useRef({ x: 0, y: 0 });
	const tooltipref = useRef();

	const handleMOver = (e) => {
		setShow(1);
		posref.current = getPoint(
			e.currentTarget,
			tooltipref.current,
			placement,
			space
		);
	};

	const handleMOut = () => setShow(0);

	return (
		<div className="Tooltip">
			{React.cloneElement(children, {
				onMouseOver: handleMOver,
				onMouseOut: handleMOut
			})}
			<Portal>
				<div
					className="Tooltip-arrow"
					style={{
						position: 'fixed',
						top: posref.current.y,
						left: posref.current.x,
						fontSize: `12px`,
						backgroundColor: 'rgba(47,51,55, 0.9)',
						color: 'white',
						pointerEvents: 'none',
						padding: '6px 9px',
						borderRadius: '4px',
						zIndex: '99999',
						whiteSpace: 'nowrap',
						opacity: show
					}}
					delay={delay}
					bg={bg}
					ref={tooltipref}
					posref={posref}
					show={show}
				>
					{text}
				</div>
			</Portal>
		</div>
	);
}

export default Tooltip;
